import { Observable } from 'rxjs';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import router from '@app/router/index.APP_TARGET';
import BPCApiServiceInstance from './bpc-api-service.instance';
import { ApiRouteType } from '@core/interfaces/core-services';

export default class BPCApiService {
  protected $adminApiService;
  protected $publicApiService;

  constructor(adminApiService: BPCApiServiceInstance, publicApiService: BPCApiServiceInstance) {
    this.$adminApiService = adminApiService;
    this.$publicApiService = publicApiService;
  }

  getBaseUrl(): string {
    return this.$adminApiService.getBaseUrl();
  }

  get(
    path: string,
    config?: object,
    apiRouteType: ApiRouteType = null,
  ): Observable<BPCGenericApiResponse> {
    return this.getApiService(apiRouteType).get(path, config);
  }

  delete(path: string, config?: object, publicRoute = null): Observable<BPCGenericApiResponse> {
    return this.getApiService(publicRoute).delete(path, config);
  }

  post(
    path: string,
    body?: object,
    config?: object,
    apiRouteType: ApiRouteType = null,
  ): Observable<BPCGenericApiResponse> {
    return this.getApiService(apiRouteType).post(path, body, config);
  }

  postWithMedia(
    path: string,
    body?: object,
    apiRouteType: ApiRouteType = null,
  ): Observable<BPCGenericApiResponse> {
    return this.getApiService(apiRouteType).postWithMedia(path, body);
  }

  put(
    path: string,
    body?: object,
    config?: object,
    apiRouteType: ApiRouteType = null,
  ): Observable<BPCGenericApiResponse> {
    return this.getApiService(apiRouteType).put(path, body, config);
  }
  patch(
    path: string,
    body?: object,
    config?: object,
    apiRouteType: ApiRouteType = null,
  ): Observable<BPCGenericApiResponse> {
    return this.getApiService(apiRouteType).patch(path, body, config);
  }

  putWithMedia(
    path: string,
    body?: object,
    apiRouteType: ApiRouteType = null,
  ): Observable<BPCGenericApiResponse> {
    return this.getApiService(apiRouteType).putWithMedia(path, body);
  }

  download(
    path: string,
    filename: string,
    config: object,
    apiRouteType: ApiRouteType = null,
  ): Observable<BPCGenericApiResponse> {
    return this.getApiService(apiRouteType).download(path, filename, config);
  }

  postDownload(
    path: string,
    filename: string,
    body?: object,
    config?: object,
    apiRouteType: ApiRouteType = null,
  ): Observable<BPCGenericApiResponse> {
    return this.getApiService(apiRouteType).postDownload(path, filename, body, config);
  }

  private getApiService(apiRouteType: ApiRouteType): BPCApiServiceInstance {
    if (apiRouteType === 'public') {
      return this.$publicApiService;
    } else if (apiRouteType === 'admin') {
      return this.$adminApiService;
    } else if (router.currentRoute.meta?.publicRoute) {
      return this.$publicApiService;
    }
    return this.$adminApiService;
  }
}

const adminApi = new BPCApiServiceInstance({ apiPath: process.env.VUE_APP_API_PATH });
const publicApi = new BPCApiServiceInstance({ apiPath: process.env.VUE_APP_PUBLIC_API_PATH });

export const bpcApi = new BPCApiService(adminApi, publicApi);
